$(document).ready(function($) {

    /* Scroll lock
 * permette di bloccare lo scrolling di pagina, thanks to barneycarroll https://gist.github.com/barneycarroll/6550066*/

    $.scrollLock = ( function scrollLockClosure() {
        'use strict';

        var $html      = $( 'html' ),
            // State: unlocked by default
            locked     = false,
            // State: scroll to revert to
            prevScroll = {
                scrollLeft : $( window ).scrollLeft(),
                scrollTop  : $( window ).scrollTop()
            },
            // State: styles to revert to
            prevStyles = {},
            lockStyles = {
                'overflow-y' : 'scroll',
                'position'   : 'fixed',
                'width'      : '100%'
            };

        // Instantiate cache in case someone tries to unlock before locking
        saveStyles();

        // Save context's inline styles in cache
        function saveStyles() {
            var styleAttr = $html.attr( 'style' ),
                styleStrs = [],
                styleHash = {};

            if( !styleAttr ){
                return;
            }

            styleStrs = styleAttr.split( /;\s/ );

            $.each( styleStrs, function serializeStyleProp( styleString ){
                if( !styleString ) {
                    return;
                }

                var keyValue = styleString.split( /\s:\s/ );

                if( keyValue.length < 2 ) {
                    return;
                }

                styleHash[ keyValue[ 0 ] ] = keyValue[ 1 ];
            } );

            $.extend( prevStyles, styleHash );
        }

        function lock() {
            var appliedLock = {};

            // Duplicate execution will break DOM statefulness
            if( locked ) {
                return;
            }

            // Save scroll state...
            prevScroll = {
                scrollLeft : $( window ).scrollLeft(),
                scrollTop  : $( window ).scrollTop()
            };

            // ...and styles
            saveStyles();

            // Compose our applied CSS
            $.extend( appliedLock, lockStyles, {
                // And apply scroll state as styles
                'left' : - prevScroll.scrollLeft + 'px',
                'top'  : - prevScroll.scrollTop  + 'px'
            } );

            // Then lock styles...
            $html.css( appliedLock );

            // ...and scroll state
            $( window )
                .scrollLeft( 0 )
                .scrollTop( 0 );

            locked = true;
        }

        function unlock() {
            // Duplicate execution will break DOM statefulness
            if( !locked ) {
                return;
            }

            // Revert styles
            $html.attr( 'style', $( '<x>' ).css( prevStyles ).attr( 'style' ) || '' );

            // Revert scroll values
            $( window )
                .scrollLeft( prevScroll.scrollLeft )
                .scrollTop(  prevScroll.scrollTop );

            locked = false;
        }

        return function scrollLock( on ) {
            // If an argument is passed, lock or unlock depending on truthiness
            if( arguments.length ) {
                if( on ) {
                    lock();
                }
                else {
                    unlock();
                }
            }
            // Otherwise, toggle
            else {
                if( locked ){
                    unlock();
                }
                else {
                    lock();
                }
            }
        };
    }());    


    /* Menu mobile 
     * Apre e chiude menu dispositivi mobile, attivato tramite media queries in header.scss */
    $('.nav-toggle').on('click',function(e){
        e.preventDefault();
        $('body').toggleClass('nav-expanded');
    });

    $('.mobile-view nav .btn-close').on('click',function(){
        $('body').removeClass('nav-expanded');
        $('.mobile-view .submenu').slideUp();
        //$('.mobile-view .submenu-content').slideUp(); //commentato perchè nascosto sottomenu in favore dei link diretti
    });



    /* Submenu desktop
     * Megamenu  */

    $('.desktop-view .submenu-toggle').click(function(e){
        e.preventDefault();
        $(this).next().addClass('is-visible');
        //$(".desktop-view .submenu").not($(this).next()).removeClass('is-visible'); 

        $('.sector-detail').removeClass('is-visible');

        $.scrollLock(true);
    });

    $('.desktop-view .btn-close').click(function(){
        $('.desktop-view .submenu').removeClass('is-visible');

        $.scrollLock(false);
    });


    /* Submenu mobile
     * Accordion mobile-only */       
    $('.mobile-view nav .submenu-toggle').click(function(e){ 
        e.preventDefault();
        
        $(this).toggleClass('active'); 
        $(this).next().slideToggle('slow');
        
         $.scrollLock(true);
        
        //$(".mobile-view nav .submenu").not($(this).next()).slideUp('slow');        
    });

    $('.mobile-view nav .submenu-content-toggle').click(function(event){    
        $(this).toggleClass('active'); 
        $(this).next().slideToggle('slow');
        //$(".mobile-view nav .submenu-content").not($(this).next()).slideUp('slow'); //commentato perchè nascosto sottomenu in favore dei link diretti 

        event.stopPropagation();
    });

    /* Submenu mobile
     * Apertura sottomenu prodotti */       
    $('.nav-toolbar .submenu-toggle').click(function(e){ 
        e.preventDefault();
        $('body').addClass('nav-expanded');
        $('.mobile-view nav .submenu').slideDown('slow');
        $('.mobile-view nav .submenu-toggle').addClass('active'); 
    });   

    /* mgigli - Apro il megamenu Prodotti anche clicco sulla breadcrumb Prodotti */
    $('.open-megamenu').click(function(e) {
        e.preventDefault();
        if ($('.page-nav.desktop-view').css('display') !== 'none') {
            $('.page-nav.desktop-view .submenu-toggle').click();
        }
        else {
            $('.nav-toolbar .submenu-toggle').click();
        }
    });

    /* Soluzioni
     * Menu categorie  */

    /*$('.sector-block .more').click(function(){
        $(this).next().addClass('is-visible');
        $(".sector-block .sector-detail").not($(this).next()).removeClass('is-visible'); 

        $('.desktop-view .submenu').removeClass('is-visible');

        $.scrollLock(true);
    });

    $('.sector-detail .btn-close').on('click',function(){
        $('.sector-detail').removeClass('is-visible');
        $.scrollLock(false);
    });*/


    
    
     /* Menu lingue 
    */


    $('.language').on('click',function(e){
        e.preventDefault();
        $('.language-menu').toggleClass('is-visible');
    });
    
    
    
    /* Ricerca */

    $('.extra-nav li:first-child a').click(function(e){
        e.preventDefault();
        $(".search-block").addClass('is-visible'); 

        $.scrollLock(true);
    });

    $('.search-block .btn-close').on('click',function(){
        $(".search-block").removeClass('is-visible');
        $.scrollLock(false);
    });


    /*Smooth anchor scroll landing 
   Presente nel template 'Scheda Prodotto' per rimandare alla mappa
   */

    $('a.anchor:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });



    /* Google map
     * Disable scroll wheel on iframe google map */

    $('.map').click(function () {
        $('.map iframe').css("pointer-events", "auto");
    });

    $( ".map" ).mouseleave(function() {
        $('.map iframe').css("pointer-events", "none"); 
    });
    
        

    /* Carousel */
    $('.block.block-image, .news-block__gallery, .services').slick();

    $('.hero.slider').slick({
        arrows: false, 
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 5000
    });

});



/* Object-fit
* Fallback IE 

if(!Modernizr.objectfit) {
    $('.hero img').each(function(){
        var imgSrc = $(this).attr('src');
        //if (! imgSrc) imgSrc = $(this).attr('data-lazy');

        var fitType = 'cover';

        if($(this).data('fit-type')) {
            fitType = $(this).data('fit-type');
        }
        //prende l'immagine e la mette come sfondo del div più vicino
        $(this).closest("div").css({ 'background' : 'transparent url("'+imgSrc+'") no-repeat center center/'+fitType, }); 
        $(this).remove(); });
}*/

if(!Modernizr.objectfit) {
    $('.video-bg video').each(function(){
        //console.log("Sono in FALLBACK OBJECT-FIT IE");
        var elementSrc = $(this).attr('src');
        if (! elementSrc) elementSrc = $(this).attr('data-lazy');

        var fitType = 'cover';

        if($(this).data('fit-type')) {
            fitType = $(this).data('fit-type');
        }

        $(this).parent().css({ 'background' : 'transparent url("'+elementSrc+'") no-repeat center center/'+fitType, });
        $(this).remove(); });
}




/* mgigli */
jQuery(function($) {
    // Interazione language switcher
    $('.language').change(function() {
        location.href = $(this).val();
    });

    // Tracciamento destinatario form con Tag Manager
    $('.contatti form [type="submit"]').click(function(e) {
        e.preventDefault();
        var dest = $('[name="destinatario"]').val();
        if (typeof dataLayer === 'object') {
            dataLayer.push({
                'destinatario': dest,
            });
        }
        else {
            console.log('destinatario: ' + dest);
        }
        setTimeout(function() { $('.contatti form').submit(); }, 500);
    });

    // Interazioni su immagini settori
    if (window.matchMedia('(min-width: 1024px)').matches) {
        var currBG = null;
        var currBGsize = null;
        $('.sector-block').hover(
            function() {
                var imgBG = $(this).attr('data-bgimg');
                if (! imgBG) return;
                currBG = $(this).css('background');
                currBGsize = $(this).css('background-size');

                $(this).css('background', "url("+imgBG+") no-repeat 0 0, -moz-linear-gradient(top, rgba(231,231,238,0.64) 0%, rgba(231,231,238,1) 100%)");
                $(this).css('background', "url("+imgBG+") no-repeat 0 0, -webkit-linear-gradient(top, rgba(231,231,238,0.64) 0%, rgba(231,231,238,1) 100%)");
                $(this).css('background', "url("+imgBG+") no-repeat 0 0, linear-gradient(to bottom, rgba(231,231,238,0.64) 0%, rgba(231,231,238,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a3e7e7ee', endColorstr='#e7e7ee',GradientType=0 )");
                $(this).css('background-size', 'cover');
            },
            function() {
                $(this).css('background', currBG);
                $(this).css('background-size', currBGsize);
            }
        );
    }

    // Click su card settore
    $('.sector-block').click(function(e) {
        location.href = $(this).find('a.more').attr('href');
    }); 

    // Bottone "torna su" nel dettaglio settore
    var winHeight = $(window).height();
    var scrollTrigger = 500, // px
        backToTop = function () {
            var scrollStop = $('footer').offset().top;
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger && (winHeight + scrollTop) < scrollStop) {
                $('#back-to-top').addClass('show');
            } else {
                $('#back-to-top').removeClass('show');
            }
        };
    backToTop();
    $(window).on('scroll', function () {
        backToTop();
    });
    $('#back-to-top').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 700);
    });

    var selPaese = $('[name="paese"]');
    var selRegione = $('.select-regione');

    // Tendina Paese nella form Contatti: preseleziono il paese della lingua attuale
    var mapLinguaPaese = {
        'it-IT': 'Italia',
        'en-US': 'United States',
        'fr-FR': 'France',
        'de-DE': 'Deutschland',
        'es-ES': 'España',
    };
    selPaese.val(mapLinguaPaese[$('html').attr('lang')]);

    // Tendina Regione nella form Contatti: la mostro solo se il Paese e' Italia
    selPaese.change(function() {
        if ($(this).val() == 'Italia') {
            selRegione.show(); 
        }
        else {
            selRegione.hide(); 
        }
    });
});
